<div class="p-datatable-customers p-datatable p-component">
  <h3>Quarterly Support Table</h3>
  <div class="table-responsive p-datatable-wrapper">
    <table class="m-0 align-middle p-datatable-table">
      <thead class="p-datatable-thead">
        <tr>
          <th colspan="2" class="text-center fw-bold">Quarter</th>
          <th colspan="2" class="text-center fw-bold">Q1</th>
          <th colspan="2" class="text-center fw-bold">Q2</th>
          <th colspan="2" class="text-center fw-bold">Q3</th>
          <th colspan="2" class="text-center fw-bold">Q4</th>
          <th colspan="2" class="text-center"></th>
        </tr>
      </thead>
      <tbody class="p-element p-datatable-tbody">
        <tr>
          <td colspan="2" class="tdhighlight fw-bold"># of Months</td>
          <td colspan="2" class="tdhighlight fw-bold">3</td>
          <td colspan="2" class="tdhighlight fw-bold">6</td>
          <td colspan="2" class="tdhighlight fw-bold">9</td>
          <td colspan="3" class="tdhighlight fw-bold">12</td>
          <td colspan="3" class="tdhighlight fw-bold"></td>
        </tr>
        <tr>
          <td colspan="2" class="tdhighlight fw-bold">Month Range</td>
          <td colspan="2" class="tdhighlight fw-bold">Apr-June</td>
          <td colspan="2" class="tdhighlight fw-bold">July-Sept</td>
          <td colspan="2" class="tdhighlight fw-bold">Oct-Dec</td>
          <td colspan="3" class="tdhighlight fw-bold">Jan-Mar</td>
        </tr>
        <tr>
          <td colspan="2" [ngClass]="'monthGpRow'" class="tdhighlight fw-bold">
            Approx. Billed GP/Month
          </td>
          <td colspan="2" [ngClass]="'monthGpRow'" class="tdhighlight fw-bold">
            3 Month GP
          </td>
          <td colspan="2" [ngClass]="'monthGpRow'" class="tdhighlight fw-bold">
            6 Month GP
          </td>
          <td colspan="2" [ngClass]="'monthGpRow'" class="tdhighlight fw-bold">
            9 Month GP
          </td>
          <td colspan="2" [ngClass]="'monthGpRow'" class="tdhighlight fw-bold">
            12 Month GP
          </td>
          <td [ngClass]="'monthGpRow'" class="tdhighlight fw-bold">
            Support %
          </td>
        </tr>
        <tr>
          <td colspan="2" class="tdhighlight fw-bold">15-20K/Month</td>
          <td colspan="2">$53,125.00</td>
          <td colspan="2">$106,250.00</td>
          <td colspan="2">$159,375.00</td>
          <td colspan="2" [ngClass]="'twelveMon'">$212,500.00</td>
          <td>25%</td>
        </tr>
        <tr>
          <td colspan="2" class="tdhighlight fw-bold">30-35K/Month</td>
          <td colspan="2">$106,250.00</td>
          <td colspan="2">$212,500.00</td>
          <td colspan="2">$318,750.00</td>
          <td colspan="2" [ngClass]="'twelveMon'">$425,000.00</td>
          <td>50%</td>
        </tr>
        <tr>
          <td colspan="2" class="tdhighlight fw-bold">50-55K/Month</td>
          <td colspan="2">$159,375.00</td>
          <td colspan="2">$318,750.00</td>
          <td colspan="2">$478,125.00</td>
          <td colspan="2" [ngClass]="'twelveMon'">$637,500.00</td>
          <td>75%</td>
        </tr>
        <tr>
          <td colspan="2" class="tdhighlight fw-bold">65-70K/Month</td>
          <td colspan="2">$212,500.00</td>
          <td colspan="2">$425,000.00</td>
          <td colspan="2">$637,500.00</td>
          <td colspan="2" [ngClass]="'twelveMon'">$850,000.00</td>
          <td>100%</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
